export default __webpack_public_path__ + "static/media/handshake.ce40efa5.jpg";